import state from './module-setting-state';
import mutations from './module-setting-mutations';
import actions from './module-setting-actions';
import getters from './module-setting-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
